
import { Component, Vue } from "vue-property-decorator";
import Header from "./module/header/header.vue";
import Footer from "./module/footer/footer.vue";
// import firebase from "firebase/app";
// import 'firebase/firebase-messaging';
// import 'firebase/firebase-app';
import Notifications from "./module/dashboard/notification/notifications.vue";
import { Constant } from "./helpers/constant";
@Component({
  components: {
    Header: Header,
    Footer: Footer,
    Notifications: Notifications

  },
})
export default class App extends Vue {
  routePath = "";
  bearerToken = "";
  beforeUpdate() {
    this.routePath = this.$router.currentRoute.path;
    this.bearerToken = localStorage.getItem("bearerToken");
  }

  mounted() {

    const MsgElem = document.getElementById("msg");
    const TokenElem = document.getElementById("token");
    const NotisElem = document.getElementById("notis");
    const ErrElem = document.getElementById("err");
    // Initialize Firebase

    // var config = Constant.config;

    // firebase.initializeApp(config);

    // const messaging = firebase.messaging();
    // messaging
    //     .requestPermission()
    //     .then(function () {
    //       //  MsgElem.innerHTML = "Notification permission granted."
    //         console.log("Notification permission granted.");

    //         // get the token in the form of promise
    //         //backend-call login time
    //         return messaging.getToken({vapidKey: 'BGaixj4hJ7bmFKLxh2LmX8eT82upeQr3cVTs1ybQus2YqLr7oLK-k3UgiL71Sa1JXLyDBYrmztdvDFfJzPLqV6U'})
    //     })
    //     .then(function(token) {
    //        // TokenElem.innerHTML = "token is : " + token
    //               localStorage.setItem("fcmtoken", token);

    //     })
    //     .catch(function (err) {
    //         //ErrElem.innerHTML =  ErrElem.innerHTML + "; " + err
    //         console.log("Unable to get permission to notify.", err);
    //     });


    // messaging.onMessage(function(payload) {

    //     var data = JSON.parse(JSON.stringify(payload.notification));
    //     NotisElem.innerHTML = NotisElem.innerHTML + JSON.stringify(payload);
    //     const noteTitle = payload.notification.title;
    //     const noteOptions = {
    //         body: payload.notification.body,
    //         icon: payload.notification.icon,
    //     };
    //     new Notification(noteTitle, noteOptions);
    // });

  }
}
